/* tslint:disable */
/* eslint-disable */
/**
 * UniCatDB API
 * UniCatDB application API documentation, with examples and live testing.  This API is built in accordance with the **JSON API 1.0 standard**. For general information, see [the documentation](http://jsonapi.org/format/).  -  JSON API standard requires use of the JSON API media type (application/vnd.api+json) for exchanging data. Clients must send all JSON API data with the headers `Content-Type: application/vnd.api+json` (POST, PATCH) and `Accept: application/vnd.api+json` (GET, DELETE). - [Relationships](http://jsonapi.org/format/#fetching-relationships) and their [inclusions](http://jsonapi.org/format/#fetching-includes) via the `include` query parameter, as specified by the standard, **are not implemented**, since there are no relationships present in the data model. - The standard does not prescribe any filtering strategies. This API implements two strategies which can be combined: **Basic filtering** based on the used [JSON API library](https://json-api-dotnet.github.io/#/filtering) and **Custom filtering** which allow for any possible query to the MongoDB server and can be extended and customize in the future. For more information about filtering, see the description of the `filter` down bellow. - **Non-standard PATCH behavior:** Sucessfull PATCH reuest always result in HTTP 200 response with the updated resource object, even if the server does not perform any additional modifications. HTTP 204 is never used in PATCH responses.  Attachment upload endpoint uses the **TUS protocol**. See [the documentation](https://tus.io/). When integrating, it is recommended to use one of the [official TUS client implementations](https://tus.io/implementations.html).  - **Supported TUS versions**:   -  1.0.0 - **Supported TUS extensions**:   - Creation   - Creation Defer Length   - Creation With Upload   - Checksum   - Checksum Trailer - **Required metadata**:   - `fileName` - name of the original file incl. file extension   - `contentType`- the MIME type of the file 
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FilterQuery,
    FilterQueryFromJSON,
    FilterQueryToJSON,
    FrequencyChart,
    FrequencyChartFromJSON,
    FrequencyChartToJSON,
    MiniMapData,
    MiniMapDataFromJSON,
    MiniMapDataToJSON,
    StatisticalData,
    StatisticalDataFromJSON,
    StatisticalDataToJSON,
} from '../models';

export interface ApiChartsFindingsFrequencyRequest {
    tenantId: string;
    aggregate: string;
    group?: string;
    filter?: FilterQuery;
    maxItemsPerGroup?: number;
}

export interface ApiChartsFindingsMinimapRequest {
    tenantId: string;
    filter?: FilterQuery;
}

export interface ApiChartsFindingsStatisticsRequest {
    tenantId: string;
    aggregate: string;
    group?: string;
    filter?: FilterQuery;
}

/**
 * no description
 */
export class ChartsApi extends runtime.BaseAPI {

    /**
     * Frequency counts of findings\' properties
     */
    async apiChartsFindingsFrequencyRaw(requestParameters: ApiChartsFindingsFrequencyRequest): Promise<runtime.ApiResponse<FrequencyChart>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling apiChartsFindingsFrequency.');
        }

        if (requestParameters.aggregate === null || requestParameters.aggregate === undefined) {
            throw new runtime.RequiredError('aggregate','Required parameter requestParameters.aggregate was null or undefined when calling apiChartsFindingsFrequency.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.aggregate !== undefined) {
            queryParameters['aggregate'] = requestParameters.aggregate;
        }

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        if (requestParameters.maxItemsPerGroup !== undefined) {
            queryParameters['max-items-per-group'] = requestParameters.maxItemsPerGroup;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/{tenantId}/charts/findings/frequency`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FrequencyChartFromJSON(jsonValue));
    }

    /**
     * Frequency counts of findings\' properties
     */
    async apiChartsFindingsFrequency(requestParameters: ApiChartsFindingsFrequencyRequest): Promise<FrequencyChart> {
        const response = await this.apiChartsFindingsFrequencyRaw(requestParameters);
        return await response.value();
    }

    /**
     * Data for frequency heatmap
     */
    async apiChartsFindingsMinimapRaw(requestParameters: ApiChartsFindingsMinimapRequest): Promise<runtime.ApiResponse<MiniMapData>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling apiChartsFindingsMinimap.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/{tenantId}/charts/findings/minimap`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MiniMapDataFromJSON(jsonValue));
    }

    /**
     * Data for frequency heatmap
     */
    async apiChartsFindingsMinimap(requestParameters: ApiChartsFindingsMinimapRequest): Promise<MiniMapData> {
        const response = await this.apiChartsFindingsMinimapRaw(requestParameters);
        return await response.value();
    }

    /**
     * Statisctical data for findings\' numerical properties
     */
    async apiChartsFindingsStatisticsRaw(requestParameters: ApiChartsFindingsStatisticsRequest): Promise<runtime.ApiResponse<StatisticalData>> {
        if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
            throw new runtime.RequiredError('tenantId','Required parameter requestParameters.tenantId was null or undefined when calling apiChartsFindingsStatistics.');
        }

        if (requestParameters.aggregate === null || requestParameters.aggregate === undefined) {
            throw new runtime.RequiredError('aggregate','Required parameter requestParameters.aggregate was null or undefined when calling apiChartsFindingsStatistics.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.aggregate !== undefined) {
            queryParameters['aggregate'] = requestParameters.aggregate;
        }

        if (requestParameters.group !== undefined) {
            queryParameters['group'] = requestParameters.group;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/{tenantId}/charts/findings/statistics`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticalDataFromJSON(jsonValue));
    }

    /**
     * Statisctical data for findings\' numerical properties
     */
    async apiChartsFindingsStatistics(requestParameters: ApiChartsFindingsStatisticsRequest): Promise<StatisticalData> {
        const response = await this.apiChartsFindingsStatisticsRaw(requestParameters);
        return await response.value();
    }

}
